import ClipboardJS from 'clipboard';
new ClipboardJS('.btn.btn-copy');
